// StatCard.js
import { HelpCircle } from "lucide-react";

const InfoTooltip = ({ content }) => (
  <div className="group relative inline-block">
    <HelpCircle className="h-4 w-5 text-gray-400 cursor-help" />
    <div className="invisible group-hover:visible absolute z-50 w-64 p-2 mt-2 text-sm 
                    text-white bg-gray-800 rounded-lg opacity-0 group-hover:opacity-100 
                    transition-opacity duration-300">
      {content}
    </div>
  </div>
);

const ShimmerEffect = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

export const StatCard = ({
  title,
  value,
  icon: Icon,
  description,
  isLoading,
  trend,
  tooltip,
  color = "#003087"
}) => (
  <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: color }}>
    <div className="flex justify-between">
      <div className="flex items-center space-x-2">
        <h3 className="text-sm font-medium text-gray-500">{title}</h3>
        {tooltip && <InfoTooltip content={tooltip} />}
      </div>
      <div className="p-2 bg-uzima-maroon-50 rounded-full">
        <Icon className="h-5 w-5" style={{ color }} />
      </div>
    </div>
    <div className="mt-4">
      {isLoading ? (
        <ShimmerEffect className="h-8 w-24 rounded" />
      ) : (
        <div className="flex items-baseline">
          <span className="text-2xl font-bold text-gray-900">{value}</span>
          {trend && (
            <span className={`ml-2 text-sm ${trend > 0 ? "text-green-600" : "text-red-600"}`}>
              {trend > 0 ? "↑" : "↓"} {Math.abs(trend)}%
            </span>
          )}
        </div>
      )}
      {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
    </div>
  </div>
);